import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledDiv = styled.div`
	padding: 50px 20px;

	@media screen and (min-width: ${CSSVars.breakpointLG}) {
		padding: 100px 40px;
	}

	h2 {
		text-align: center;
		font-size: ${CSSVars.fontSize2XL};
		color: ${CSSVars.gray900};
		max-width: 920px;
		margin: 0 auto 50px;
	}

	.show-more {
		margin: 50px auto;
		color: ${CSSVars.blue500};
		background: none;
		font-size: ${CSSVars.fontSizeSM};

		.icon {
			padding-top: 2px;
		}

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			font-size: ${CSSVars.fontSizeMD};
		}
		&:hover {
			background: none;
			color: ${CSSVars.blue300};
		}
	}

	.companies-wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		max-width: 1200px;
		flex-wrap: wrap;
		margin: 0 auto;
		gap: 14px;

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			gap: 18px;
		}

		.tile {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			flex: 0 0 auto;
			width: 104px;
			height: 104px;
			background: ${CSSVars.white};
			border: 1px solid ${CSSVars.gray100};
			border-radius: 18px;
			text-decoration: none;
			color: inherit;
			transition: transform 0.2s ease, box-shadow 0.2s ease,
				border-color 0.2s ease;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				width: 116px;
				height: 116px;
				border-radius: 20px;
			}

			&:hover {
				transform: translateY(-3px);
				border-color: ${CSSVars.gray200};
				box-shadow: 0 10px 22px rgba(16, 24, 40, 0.08);
			}

			.icon {
				width: 44px;
				height: 44px;
				transition: transform 0.2s ease;

				@media screen and (min-width: ${CSSVars.breakpointMD}) {
					width: 48px;
					height: 48px;
				}
			}

			&:hover .icon {
				transform: scale(1.06);
			}
		}
	}
`;
